import { useContext, useEffect } from "react";
import Spin from "../../components/general/antd/spin";
import SearchFilterCard from "../../components/general/filter-card";
import PartnerFilter from "../../components/partner-statistics/partner-filter";
import TrademarkStatisticsContext from "../../context/statistcs-trademark/context";
import AppContext from "../../context/app/context";
import TrademarkStatisticsContextProvider from "../../context/statistcs-trademark/provider";
import styles from "./style.module.scss";
import StatisticsSection from "../../components/partner-statistics/partner-data";

const Partner: React.FC = () => {
  const { direction } = useContext(AppContext);
  const { loading, query, actions } = useContext(TrademarkStatisticsContext);

  useEffect(() => {
    actions.getData();
  }, [query, direction]);

  return (
    <>
      <div dir={direction} className={styles.container}>
        <SearchFilterCard
          formId="partner-filter"
          searchValue={undefined}
          setSearchValue={() => { }}
          visiableSearch={true}
          onReset={() => {
            actions.setQuery({
              page: query?.page,
              perPage: query?.perPage,
            });
            const form = document.getElementById("partner-filter");
            if (form) {
              form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
            }
          }}
          resetLoading={loading.includes("list")}
          applyLoading={loading.includes("list")}
        >
          <PartnerFilter />
        </SearchFilterCard>
        {loading.includes("list") ? (
          <Spin />
        ) : (
          <StatisticsSection />
        )}
      </div>
    </>
  );
};

const PartnerPage = () => {
  return (
    <TrademarkStatisticsContextProvider>
      <Partner />
    </TrademarkStatisticsContextProvider>
  );
};

export default PartnerPage;
